import React, { useState, useRef, useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import { FaBars } from "react-icons/fa"
import { MdClose } from "react-icons/md"

function Navbar() {
  const [ showMenu, setShowMenu ] = useState(false);
  const menuContainerRef = useRef(null);

  useEffect(() =>{
    if(showMenu){
      menuContainerRef.current.style.height = "100vh";
    } else {
      menuContainerRef.current.style.height = "0px";
    }
  },[showMenu])

  return (
    <section className="nav-section">
      <nav className="nav">
        <header className="nav-header">
            <div className="open-menubars-div">
              <FaBars className="open-menu-bars" onClick={()=>setShowMenu(true)}/>
            </div>
        
            <div className="menu-container" ref={menuContainerRef}>
              <div className="close-menubars-div">
                <MdClose className="close-menu-bars" onClick={()=>setShowMenu(false)}/>
              </div>
           
              <ul className="menu" onClick={() => setShowMenu(false)}>
                <li>
                  <HashLink to="#skill-section" className="menu-link">skills</HashLink>
                </li>

                <div className="menu-dash">-</div>

                <li>
                  <HashLink to="#project-section"  className="menu-link">Projects</HashLink>
                </li>

                <div className="menu-dash">-</div>

                <li>
                  <HashLink to="#resume-section"  className="menu-link">Resume</HashLink>
                </li>
              </ul>
            </div>

          <div className="contact-btn-div">
            <HashLink to="#contact-form" className="contact-btn">Contact</HashLink>
          </div>
        </header>
      </nav>
    </section>
  );
}

export default Navbar;
